const DeleteIcon = () => {
    return <img src={process.env.PUBLIC_URL + '/style/img/btn-icon/ico-delete.png'} />;
};

export default DeleteIcon;
